import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ContactUsRequest {
  firstName: string;
  lastName: string;
  email: string;
  cellNumber: string;
  purposeOfEnquiry: string;
  comments: string;
}

@Injectable({
  providedIn: 'root',
})
export class ContactUsService {
  private apiUrl = environment.APP_BASE_URL + '/clinic-onboarding/contact';

  constructor(private http: HttpClient) {}

  submitContactUs(request: ContactUsRequest): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}/submit`, request);
  }
}
